import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../../components/partials/PageTitle";
import Permissions from "../../../components/settings/Permissions";
import Roles from "../../../components/settings/Roles";

const Settings = () => {
  const navigate = useNavigate();

  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const [tab, setTab] = useState("roles");

  const breadcrumb = {
    from: {
      title: "settings",
      link: "/admin/settings",
    },
    current: {
      title: "roles/permissions",
      link: null,
    },
  };

  // useEffect(() => {
  //   if (!user_permissions?.some(permission => permission.name === 'settings module') || !user_permissions?.some(permission => permission.name === 'roles/permissions module')) {
  //     navigate('/admin/dashboard')
  //   }
  // }, [navigate, user_permissions])
  return (
    <>
      {/* page title */}
      <PageTitle title='Roles/Permission' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div>
                <ul className='nav nav-pills bg-nav-pills nav-justified mb-3'>
                  <li className='nav-item cursor-p'>
                    <span
                      onClick={() => setTab("roles")}
                      aria-expanded='false'
                      className={`nav-link rounded-0 p-tab-y-1 ${
                        tab === "roles" && "active"
                      } border`}
                    >
                      <i className='mdi mdi-home-variant d-md-none d-block'></i>
                      <span className='d-none d-md-block'>Roles</span>
                    </span>
                  </li>
                  <li className='nav-item cursor-p'>
                    <span
                      // data-bs-toggle='tab'
                      onClick={() => setTab("permission")}
                      aria-expanded='true'
                      className={`nav-link rounded-0 ${
                        tab === "permission" && "active"
                      } border`}
                    >
                      <i className='mdi mdi-account-circle d-md-none d-block'></i>
                      <span className='d-none d-md-block'>
                        Access Permissions
                      </span>
                    </span>
                  </li>
                </ul>

                {tab === "roles" && (
                  <div className='roles active' id='charts_of_accounts'>
                    <Roles />
                  </div>
                )}
                {tab === "permission" && (
                  <div className='active' id='journals'>
                    <Permissions />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
